import React from 'react'
import { Message } from 'semantic-ui-react'
import Conditional from './Conditional'

interface IFormErrorMessagesProps {
  heading?: string
  errorsList?: string[]
  show: boolean
  errorRef?
}

const FormErrorMessages = (props: IFormErrorMessagesProps) => {
  return (
    <>
      <Conditional
        if={props.show && props.errorsList && props.errorsList.length > 0}
      >
        <Message tabIndex={0} negative>
          <Conditional if={props.heading && props.heading.length > 0}>
            <Message.Header>{props.heading}</Message.Header>
          </Conditional>
          <Conditional if={props.errorsList && props.errorsList.length > 0}>
            <Message.List tabIndex={0}>
              {props.errorsList?.map((item, index) => {
                return <Message.Item key={index}>{item}</Message.Item>
              })}
            </Message.List>
            <input
              ref={props.errorRef}
              className="sr-only"
              type="text"
              aria-label={props.errorsList?.toString()}
            />
          </Conditional>
        </Message>
      </Conditional>
    </>
  )
}

FormErrorMessages.displayName = 'FormErrorMessages'
export default FormErrorMessages
